export default __webpack_public_path__ + "static/media/funnel.c8f71956.svg";